<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
    <circle cx="9.5" cy="9.81689" r="9.5" fill="#D9D9D9"/>
    <path d="M6 6.45068L13 13.4507" stroke="black"/>
    <path d="M6 13.4507L13 6.45068" stroke="black"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconCross'
}
</script>
